import type { OptionsDocument, Crew } from 'paintscout'
import { formatName } from '../../util/format-name'

export function getCrews({
  options,
  searchCrewValue,
  includeTrashed
}: {
  options: OptionsDocument
  searchCrewValue?: string
  includeTrashed?: boolean
}): Crew[] {
  const search = searchCrewValue?.toLowerCase() ?? ''
  const filteredCrews = Object.values(options.options?.crews?.values ?? {}).filter((crew) => {
    if (crew.trashed && !includeTrashed) return false
    if (!search) return true
    const fields = [crew.name, formatName(crew.projectManager), formatName(crew.siteLead)]
    return fields.some((field) => field.toLowerCase().includes(search))
  })
  return filteredCrews || []
}
